module.exports = __webpack_public_path__ + "img/logo_small.ad1ff3ff.png";